// vim: set ts=2 sts=2 sw=2 et:

import React from "react";

import AthleteCardView from "./broadcast/AthleteCardView";
import BroadcastCanvas from "./broadcast/BroadcastCanvas";
import { buildFichaView } from "./broadcast/fichaView";
import { FALLBACK_TOURNAMENT_NAME, getSessionLabel } from "./broadcast/overlayView";
import type { StreamingDisplayState } from "./StreamingLiveClient";

// Ficha del atleta: sigue al intento actual apenas se resuelve el anterior (immediate-next), así que no hay
// veredicto que mostrar; la foto va enmarcada en el anillo del escudo.
const AthleteCard = (state: StreamingDisplayState) => (
  <BroadcastCanvas label="Athlete Card Display">
    <AthleteCardView
      tournamentName={state.broadcast.meetName?.trim() || FALLBACK_TOURNAMENT_NAME}
      sessionLabel={getSessionLabel(state.platformRef)}
      sponsors={state.broadcast.sponsors ?? []}
      athlete={state.attempt === null ? null : buildFichaView(state.attempt)}
      waitingForNext={state.waitingForNext}
    />
  </BroadcastCanvas>
);

export default AthleteCard;
